<template>
  <div id="weekrackingkpi">
    <div class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
      <!-- 加载动画 -->
      <div class="loads" v-show="isload">
        <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
      </div>
      <div class="prductCategory">
        <!--  <el-dropdown @command="selectProduct" trigger="click">
           <span style="color: white" class="el-dropdown-link">
              产线筛选：{{ product["key"] ? product["title"] : "所有产线"
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="item"
                v-for="(item, i) in productList"
                :key="i"
                >{{ item.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown> -->
      </div>
      <div class="etime">{{ now }}</div>
      <div class="etime1">最后更新:{{ updateTimeText }}</div>
      <div @click="signOut" class="power">
        <i style="cursor: pointer" class="el-icon-back"></i>
      </div>
      <div class="logoImg">
        <img style="height: 0.8rem" :src="logoSrc" />
      </div>
      <header class="w-100 h-10 flex j-center a-center">
        <dv-decoration-5 :dur="10" style="position: absolute; bottom: 0; right: 0; height: 50%" class="w-100" />
        <div class="font-big font-weight light-title" style="font-size:0.65rem;letter-spacing:0.1rem;">
          {{ title }}
          <!--  <span v-if="producingStatus==1">(停线)</span> -->

        </div>
        <div v-if="dayText" class="gradient-title" style="margin-left:20px;font-size:0.28rem;font-weight: bold;">
          <span>{{ this.dayText }}</span><br />
          <span>{{ this.week }}</span>
        </div>
        <!--		临时取消
				<div @click="monthlyLink" style="cursor:pointer;" class="font-big font-weight gradient-title">
				  {{ product["key"] ? product["title"] : "Dashboard" }}
				</div>
				 -->

        <!-- <div :class="'circle'+producingStatus"></div> -->


        <!-- <div :class="'status status-' + producingStatus">
          <div class="status-text">
            {{
              producingStatus === 0
              ? "正常生产"
              : producingStatus === 1
                ? "计划停机"
                : producingStatus === 2
                  ? "非计划停机"
                  : "无生产计划"
            }}
          </div>
        </div> -->
      </header>
      <div style="width:100%;height:100%">
        <div style="text-align:right;widht:100%">
          <el-button @click="reportClick()" size="mini" type="primary" icon="el-icon-pie-chart">问题解决报表</el-button>
          <el-button @click="openFilterModal()" size="mini" type="primary" icon="el-icon-edit">筛选入口</el-button>
        </div>
        <div class="flex h-100 flex-wrap">
          <div class="p w-33 h-90 flex">
            <!--基础数据汇总OEE-->
            <oee-productline-total :updateTime="updateTime" :bean="whyData"></oee-productline-total>
          </div>
          <div class="p w-33 h-90 flex">
            <!--基础数据汇总FTQ-->
            <oee-productline-total :updateTime="updateTime" :bean="a3Data"></oee-productline-total>
          </div>
          <div class="p w-33 h-90 flex">
            <!-- 基础数据汇总 Scrap-->
            <oee-productline-total :updateTime="updateTime" :bean="d8Data"></oee-productline-total>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="条件筛选" @close="closeModal()" :close-on-click-modal="false" :visible.sync="dialogFormVisible"
      width="50%">
      <el-form :rules="formRules" ref="form" size="small" :model="form" label-width="120px">
        <el-row :gutter="22">
          <el-col :span="24">
            <el-form-item prop="date" label="发生日期：">
              <el-date-picker v-model="form.date" style="width:100%" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="lineUUID" label="产线：">
              <el-select v-model="form.lineUUID" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in lineList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item prop="processCategory" label="报告类型">
              <el-select v-model="form.processCategory" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in processCategoryList" :key="item.uuid" :label="item.title" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="dept" label="责任部门：">
              <el-select v-model="form.dept" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in deptList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="device" label="设备名称：">
              <el-select v-model="form.device" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in deviceList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="status" label="报告状态">
              <el-select v-model="form.status" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option :label="'进行中'" :value="0"></el-option>
                <el-option :label="'已完成'" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="keyword" label="关键字">
              <el-input v-model="form.keyword" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="pageSize" label="显示条数：">
              <el-input-number v-model="form.pageSize" style="width: 140px" controls-position="right" :precision="0"
                :min="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="9">
            <el-button type="primary" size="small" @click="okFilter()" icon="search">
              确认
            </el-button>
            <el-button type="danger" v-if="!form.uuid" size="small" icon="reload" @click="resetForm()"
              style="margin-left: 2px">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template> 

<script>
import format from "date-fns/format";
import API from "@/utils/api";
import router from "../../../router";
import oeeProductlineTotal from "./component/fr-issue-table.vue";
export default {
  name: "fr-group-view",
  components: {
    oeeProductlineTotal,
  },
  data() {
    return {
      updateTime: 0,
      updateTimeText: null,
      logoSrc: "/assets/img/logo_light.png",
      now: null,
      week: null,
      dayText: null,
      websock: null,
      isload: false,
      producingStatus: 0,
      title: "问题解决状态可视化系统",
      product: {},
      productList: [],
      form: {
        date: null,
        pageSize: 20,
        lineUUID: null,
        device: null,
        status: null,
        dept: null,
        keyword: null,
        processCategory: null
      },
      filtersParams: {
        pageSize: 20,
        lineUUID: null,
        device: null,
        dept: null,
        status: null,
        startTime: null,
        endTime: null,
        keyword: null,
        processCategory: null
      },
      whyData: {
        id: "why",
        url: '/fr/5why',
        title: "5-WHY",
        deptData: [],
        issueList: [],
      },
      a3Data: {
        id: "A3",
        url: '/fr/a3',
        kpi: 5,
        title: "A3",
        deptData: [],
        issueList: [],
      },
      d8Data: {
        id: "8d",
        url: '/fr/8d',
        title: "8D",
        deptData: [],
        issueList: [],
      },
      lineWeekList: [],
      topData: {},
      vheight: 800,
      too: 1000000,
      dialogFormVisible: false,
      deptList: [],
      deviceList: [],
      processCategoryList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      formRules: {

      }
    };
  },
  mounted() {
    var uuid = this.$route.query.key;
    var week = this.$route.query.week;
    this.product["key"] = uuid;

    var now = new Date();
    var weekd = new Array(
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    );

    if ('FRI' == week) {
      now.setDate(now.getDate() - 3);
      this.dayText = format(now, "MM-dd");
      this.week = weekd[now.getDay()];
    } else if ('SAT' == week) {
      now.setDate(now.getDate() - 2);
      this.dayText = format(now, "MM-dd");
      this.week = weekd[now.getDay()];
    } else if ('SUN' == week) {
      now.setDate(now.getDate() - 1);
      this.dayText = format(now, "MM-dd");
      this.week = weekd[now.getDay()];
    }

    this.product['week'] = week || null;

    this.isload = true;
    //this.webSocket();
    this.loadData();
    this.loadBoardTitle();
    //钟表
    setInterval(this.clock, 1000);
    //配置项
    this.loadOptions();

    var that = this;
    var height = document.documentElement.clientHeight;
    that.vheight = height;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        that.vheight = window.fullHeight; // 实时高
      })();
    };
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    okFilter() {
      Object.assign(this.filtersParams, this.form);
      if (this.form['date'] && this.form['date'].length > 0) {
        this.filtersParams['startTime'] = this.form['date'][0];
        this.filtersParams['endTime'] = this.form['date'][1];
      } else {
        this.filtersParams['startTime'] = null;
        this.filtersParams['endTime'] = null;
      }
      this.closeModal();
      this.loadData();
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
    },
    signOut() {
      router.back();
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/oee/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/oee/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("OEE socket连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("OEE socket连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("OEE socket断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log("socket 数据刷新");
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    loadData() {

      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        var params = {};
        Object.assign(params, this.filtersParams);
        if (params['startTime']) {
          delete params['date'];
          params['startTime'] = params['startTime'].setHours(0, 0, 0, 0);
        }
        if (params['endTime']) {
          delete params['date'];
          params['endTime'] = params['endTime'].setHours(23, 59, 59, 0);
        }

        this.isload = true;
        API.frDppGroup(params)
          .then((res) => {
            this.isload = false;
            if (res.success == true) {
              var value = res.value;
              this.d8Data['issueList'] = value['d8List'];
              this.d8Data['deptData'] = value['d8Dept'];
              this.a3Data['issueList'] = value['a3List'];
              this.a3Data['deptData'] = value['a3Dept'];
              this.whyData['issueList'] = value['whyList'];
              this.whyData['deptData'] = value['whyDept'];
              var now = new Date().getTime();
              this.updateTime = now;
              this.updateTimeText = format(now, "yyyy-MM-dd HH:mm:ss");
            }
          })
          .catch((error) => {
            this.isload = false;
            console.log(error);
          });
      }
    },
    resetForm() {
      this.form = {
        date: null,
        pageSize: 20,
        lineUUID: null,
        device: null,
        status: null,
        dept: null,
        keyword: null,
        processCategory: null
      }
    },
    loadOptions() {
      //加载配置项列表
      var that = this;
      API.loadOeeDevice()
        .then((res) => {
          if (res.success === true) {
            this.deviceList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
      API.loadOrgDept()
        .then((res) => {
          if (res.success === true) {
            this.deptList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });

      const params = {
        Expanded: "",
        Selectable: ""
      };

      API.listTree(params)
        .then((res) => {
          if (res.success === true) {
            this.processCategoryList = res.list;
            console.log(this.processCategoryList);
          }
        }).catch((error) => {
          console.log(error);
        });
    },

    selectProduct(item) {
      this.product = item || {};
      this.isload = true;
      this.loadData();
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },
    closeModal() {
      this.dialogFormVisible = false;
    },
    openFilterModal() {
      this.dialogFormVisible = true;
      Object.assign(this.form, this.filtersParams);
      if (this.filtersParams.startTime && this.filtersParams.endTime) {
        this.form['date'] = [this.filtersParams.startTime, this.filtersParams.endTime];
      }
    },
    reportClick(){
      this.$router.push({
        path: "/fr/group_report"
      });
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: electronicFont;
  src: url("data:application/octet-stream;base64,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");
}

.p {
  padding: 0rem 0.05rem 0.1rem;
}

.prductCategory {
  color: white;
  position: absolute;
  right: 25%;
  top: 20px;
  z-index: 999999;
}

header {
  background: url("../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
}

.circle2 {
  margin-left: 20px;
  display: block;
  background: black;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  background: radial-gradient(circle at 10px 10px, #ff0000, #000);
}

.circle1 {
  margin-left: 20px;
  display: block;
  background: black;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  background: radial-gradient(circle at 10px 10px, #5cabff, #000);
}

.circle0 {
  margin-left: 20px;
  display: block;
  background: black;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  background: radial-gradient(circle at 10px 10px, #00e690, #000);
}

.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.etime {
  position: absolute;
  right: 30px;
  top: 0.1rem;
  font-weight: bold;
  color: white;
  font-family: electronicFont !important;
  font-size: 0.55rem !important;
  z-index: 999;
}

.etime1 {
  position: absolute;
  right: 30px;
  top: 0.85rem;
  color: white;
  font-family: electronicFont !important;
  font-size: 0.25rem !important;
  z-index: 999;
}

.status {
  position: relative;
  left: 0.2rem;
  line-height: 0.45rem;
  height: 0.45rem;
  opacity: 0.9;
  filter: alpha(opacity=60);
  -moz-opacity: 0.6;
  display: table-cell;
  vertical-align: middle;
  z-index: 1;
}

.status-text {
  text-align: center;
  margin: auto;
  color: #fff;

  width: 1.3rem;
  //	padding: 0 5px 0 5px;
  text-align: center;
  font-weight: bold;
  font-size: 0.24rem;
}

.status-1 {
  background: #666666;
}

.status-0 {
  background: #00e690;
}

.status-2 {
  background: #f44;
}

.status-3 {
  background: #666666;
}

#weekrackingkpi {
  width: 100%;
  height: 100%;
  background-color: #00194C;
  color: #fff;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/fr/groups/board.vue